import clsx from "clsx";
import React from "react";
import Loading from "./Loading";
import Ellipsis from "./Ellipsis";

interface Props {
  //TODO:hmm now isFullPage prop is weird after
  //making separate CenteredLoading
  isFullPage?: boolean;
  justEllipsis?: boolean;
}

const CenteredLoading: React.FC<Props> = ({
  isFullPage,
  justEllipsis = false,
}) => {
  //TODO: styling here is fucked up - see in SimpleDefPopup
  return (
    <div
      className={clsx(["flex justify-center w-full", { "pt-24": isFullPage }])}
    >
      <div className="relative w-24">
        <div className="absolute left-0">
          {justEllipsis ? <Ellipsis /> : <Loading />}
        </div>
      </div>
    </div>
  );
};

export default CenteredLoading;
